// AuthContext.js
import { createContext, useState, useContext } from "react";
import { redirect, useNavigate } from "react-router-dom";
import { errorToast, successToast } from "../components/common/toast";

// Create a context for authentication
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const navigate = useNavigate()

    const login = () => {
        setIsAuthenticated(true);
    };

    const logout = () => {
        if (window.confirm(`Are you sure you want to logout?`)) {
            try {
                setIsAuthenticated(false);
                localStorage.clear()
                navigate('/');
                successToast("Logout successfully!!")
            } catch (error) {
                errorToast("Error deleting user: " + error.message);
            }
        }
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
